import styled from 'styled-components';

import { Input as SemanticInput } from 'semantic-ui-react';

import {
  Button as ButtonLayoutComponent,
  Text as TextLayoutComponent,
  Checkbox as CheckBoxComponent,
} from '@playbookux/playbook-web-core';

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
`;

export const Container = styled.div`
  margin-top: 5px;
  padding: 0px 10px;
  width: 100%;
`;

export const Button = styled(ButtonLayoutComponent)`
  width: 25%;
`;

export const Content = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 10px;
  flex-direction: row;
  align-items: center;

  &:not(:first-child) {
    & > ${Button} {
      margin-left: auto;
    }
  }
`;

export const Input = styled(SemanticInput)`
`;

export const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 25%;
`;

export const Checkbox = styled(CheckBoxComponent)``;

export const Text = styled(TextLayoutComponent)``;
